__turbopack_context__.v({
  "accordionBody": "productFeatureCarousel-module__hajRBW__accordionBody",
  "accordionDivider": "productFeatureCarousel-module__hajRBW__accordionDivider",
  "accordionHeader": "productFeatureCarousel-module__hajRBW__accordionHeader",
  "accordionIcon": "productFeatureCarousel-module__hajRBW__accordionIcon",
  "accordionItem": "productFeatureCarousel-module__hajRBW__accordionItem",
  "accordionLabel": "productFeatureCarousel-module__hajRBW__accordionLabel",
  "accordionList": "productFeatureCarousel-module__hajRBW__accordionList",
  "additionalText": "productFeatureCarousel-module__hajRBW__additionalText",
  "animating": "productFeatureCarousel-module__hajRBW__animating",
  "carouselGrid": "productFeatureCarousel-module__hajRBW__carouselGrid",
  "carouselItem": "productFeatureCarousel-module__hajRBW__carouselItem",
  "carouselRoot": "productFeatureCarousel-module__hajRBW__carouselRoot",
  "carouselScroll": "productFeatureCarousel-module__hajRBW__carouselScroll",
  "carouselTrack": "productFeatureCarousel-module__hajRBW__carouselTrack",
  "categoryBlock": "productFeatureCarousel-module__hajRBW__categoryBlock",
  "categoryProducts": "productFeatureCarousel-module__hajRBW__categoryProducts",
  "categoryTitle": "productFeatureCarousel-module__hajRBW__categoryTitle",
  "colorFinishBlock": "productFeatureCarousel-module__hajRBW__colorFinishBlock",
  "colorFinishLabel": "productFeatureCarousel-module__hajRBW__colorFinishLabel",
  "ctaButton": "productFeatureCarousel-module__hajRBW__ctaButton",
  "fadeImage": "productFeatureCarousel-module__hajRBW__fadeImage",
  "fadeIn": "productFeatureCarousel-module__hajRBW__fadeIn",
  "headerBottomRowGrid": "productFeatureCarousel-module__hajRBW__headerBottomRowGrid",
  "headerDescription": "productFeatureCarousel-module__hajRBW__headerDescription",
  "headerEyebrow": "productFeatureCarousel-module__hajRBW__headerEyebrow",
  "headerGrid": "productFeatureCarousel-module__hajRBW__headerGrid",
  "headerTitle": "productFeatureCarousel-module__hajRBW__headerTitle",
  "headerWrapper": "productFeatureCarousel-module__hajRBW__headerWrapper",
  "iconOpen": "productFeatureCarousel-module__hajRBW__iconOpen",
  "mainImage": "productFeatureCarousel-module__hajRBW__mainImage",
  "nextBtn": "productFeatureCarousel-module__hajRBW__nextBtn",
  "optionsHeadline": "productFeatureCarousel-module__hajRBW__optionsHeadline",
  "pfc-option-block": "productFeatureCarousel-module__hajRBW__pfc-option-block",
  "pfcWrapper": "productFeatureCarousel-module__hajRBW__pfcWrapper",
  "prevBtn": "productFeatureCarousel-module__hajRBW__prevBtn",
  "previewImage": "productFeatureCarousel-module__hajRBW__previewImage",
  "productCard": "productFeatureCarousel-module__hajRBW__productCard",
  "productCardImg": "productFeatureCarousel-module__hajRBW__productCardImg",
  "productCardLabel": "productFeatureCarousel-module__hajRBW__productCardLabel",
  "productDetails": "productFeatureCarousel-module__hajRBW__productDetails",
  "productInfoGrid": "productFeatureCarousel-module__hajRBW__productInfoGrid",
  "productLeft": "productFeatureCarousel-module__hajRBW__productLeft",
  "productRight": "productFeatureCarousel-module__hajRBW__productRight",
  "swatchColor": "productFeatureCarousel-module__hajRBW__swatchColor",
  "swatchGroup": "productFeatureCarousel-module__hajRBW__swatchGroup",
  "swatchItem": "productFeatureCarousel-module__hajRBW__swatchItem",
  "swatchLabel": "productFeatureCarousel-module__hajRBW__swatchLabel",
  "thumbActive": "productFeatureCarousel-module__hajRBW__thumbActive",
  "thumbAspect": "productFeatureCarousel-module__hajRBW__thumbAspect",
  "thumbImage": "productFeatureCarousel-module__hajRBW__thumbImage",
  "thumbWrapper": "productFeatureCarousel-module__hajRBW__thumbWrapper",
  "thumbnailRow": "productFeatureCarousel-module__hajRBW__thumbnailRow",
  "viewMoreBtn": "productFeatureCarousel-module__hajRBW__viewMoreBtn",
});
